<template>
  <div class="color-selector-holder" :class="getHolderClass">
<!--    <div
      v-for="(color, index) in getColorOptions"
      :id="'hex' + index"
      :key="index"
      class="color-box"
      :style="colorSquare(color)"
      @mousedown="handleMouseDown"
      @click="colorSelected(color)"
    >-->
      <div
          v-for="(color, index) in getPatternReferences"
          :id="'hex' + index"
          class="color-box"
          @mousedown="handleMouseDown"
          @click="patternSelected(index)"
      >
      <svg width="100%" height="100%"  fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" :fill="getPattern(index)" />
      </svg>
    </div>
  </div>
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';


export default {
  name: 'ColorSelector',
  props: [
    'format',
    'type'
  ],
/*  data () {
    return {
      colors: ['#a95e5e', '#592121', '#e08840', '#b6c3dc', '#73a43e', '#9a4fb0', '#e08840'],
    };
  },*/
  computed: {
    getPatternReferences () {
      return useSegmentStore().getPatternReferences;
    },
    getHolderClass () {
      return (this.$props.format !== 'context') ? 'color-selector-box' : 'color-selector-box-context';
    }
  },
  emits: [
    'color'
  ],
  methods: {

    getPattern (index) {
      return useSegmentStore().getPatternReferences[index].url();
    },
    colorSquare (colorHex) {
      return {
        'background-color': colorHex
      };
    },
    patternSelected (num) {
      const segmentStore = useSegmentStore();
      if (this.$props.type === 'pipe') {
        segmentStore.changeSelectedPipeSegmentPattern(num);
      } else {
        segmentStore.changeSelectedSlopeSegmentPattern(num);
      }
      // this.$emit('color', color);
    },
    handleMouseDown (e) {
      e.stopImmediatePropagation();
    }
  },
};
</script>

<style scoped>

color-selector {
  display: flex;
  flex-direction: row;
  align-items: center;

}
.color-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  margin: 2px;
  cursor: pointer;
  border: transparent solid 3px;
  z-index: 2000;
}
.data-label {
  font-size: small;
  width: 17%;
}
.color-circle-plus {
  cursor: pointer;
  font-size: 20px;
  width: 13px;
  height: 13px;
  border-radius: 10px;
  background-color: #c5c5c5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
}
.color-selector-box {
  display: flex;
  position: absolute;
  background-color: white;
  padding: 5px;
  margin-top: -10px;
  border: 1px black solid;
}

.color-selector-box-context {
  display: flex;
  width: 100%;
  flex-wrap: wrap;


}

.color-selector-holder {
  top: 15px;
  left: 10px;
  z-index: 1000;
}
</style>